import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ExtendTransformation } from '../../../dataflow/extendtransformation';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FLOW } from '../IDataflow';
import { DataFlowSchemaAdapterUtils } from '../dataflow-schema-adapter-utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ExtendTransformation),
    asynchronous: true
})
export class ExtendTransformationAdapter extends TransformationAdapter<ExtendTransformation> {
    public async getDslScript(extendTransformation: ExtendTransformation): Promise<string> {
        const props: string[] = [
            DataFlowSchemaAdapterUtils.getOutputDefinitionDsl(extendTransformation),
            `method: '${extendTransformation.method}'`
        ];
        const expression = props.filter((prop) => !!prop).join(',\n\t');
        const partition = TransformationAdapter.getPartitionDslScript(extendTransformation);

        const knownProps = `${expression}${partition ? ',\n\t' : ''}${partition}`;
        const unknownProps = this._getUnknownProps(extendTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(extendTransformation)} ${
                ExtendTransformation.MODEL.name
            }(${transformationData}) ` + `${FLOW} ${this._getOutputStreams(extendTransformation)}`
        );
    }
}
